export const colors = [
  ["белый", "#ffffff"],
  ["бурый", "#c9a391"],
  ["зелёный", "#4e9d45"],
  ["красный", "#eb262b"],
  ["синий", "#245f8d"],
  ["тёмно-синий", "#474d66"],
  ["чёрный", "#2b2a28"],
].map(([name, value]) => ({ name, value }));

export function colorsByName(names) {
  return colors.filter((c) => names.includes(c.name));
}
